export enum RunState {
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}
